import { render, staticRenderFns } from "./Styleguide.vue?vue&type=template&id=ab5368fe"
import script from "./Styleguide.vue?vue&type=script&lang=ts"
export * from "./Styleguide.vue?vue&type=script&lang=ts"
import style0 from "./Styleguide.vue?vue&type=style&index=0&id=ab5368fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports